// extracted by mini-css-extract-plugin
export default {"game__header":"header_game__header__H2nSH","smile":"header_smile__qgvQZ","numbers":"header_numbers__v8yeN","number":"header_number__3cRiv"};